export default __webpack_public_path__ + "static/media/spaceXhub1.40bd4a8a.png";